// lovers — lk01 "Sevgi kuni" / 1-yil birga card.
//
// Tender rose-paper card with two intertwined heart outlines. The portrait
// (when supplied) sits in the overlap where the hearts meet — a visual cue
// for two people becoming one. Pinyon Script for the couple's names.
import { Photo, type LayoutCtx } from "./_shared";

export function LoversLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `radial-gradient(circle at 50% 30%, ${accent}26 0%, ${bg} 60%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}26`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          SEVGI KUNI
        </div>

        {/* Twin hearts with portrait in overlap */}
        <div style={{ width: "64%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <svg
            viewBox="0 0 100 100"
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
          >
            <defs>
              <clipPath id="loversOverlap">
                <path d="M52 38 C 52 28, 62 22, 68 30 C 74 22, 86 28, 86 40 C 86 56, 68 70, 60 78 C 52 70, 34 56, 34 40 C 34 28, 46 22, 52 30 Z" />
                <path d="M48 38 C 48 28, 38 22, 32 30 C 26 22, 14 28, 14 40 C 14 56, 32 70, 40 78 C 48 70, 66 56, 66 40 C 66 28, 54 22, 48 30 Z" />
              </clipPath>
            </defs>
            <g clipPath="url(#loversOverlap)">
              {photo ? (
                <image href={photo} x="0" y="0" width="100" height="100"
                       preserveAspectRatio="xMidYMid slice" />
              ) : (
                <>
                  <rect width="100" height="100" fill={bg} />
                  <circle cx="50" cy="48" r="40" fill={`${accent}33`} />
                </>
              )}
            </g>
            {/* Heart outlines on top */}
            <g fill="none" stroke={accent} strokeWidth="1.1" opacity="0.95">
              <path d="M52 38 C 52 28, 62 22, 68 30 C 74 22, 86 28, 86 40 C 86 56, 68 70, 60 78 C 52 70, 34 56, 34 40 C 34 28, 46 22, 52 30 Z" />
              <path d="M48 38 C 48 28, 38 22, 32 30 C 26 22, 14 28, 14 40 C 14 56, 32 70, 40 78 C 48 70, 66 56, 66 40 C 66 28, 54 22, 48 30 Z" />
            </g>
            {/* Compass dots */}
            {[8, 92].map((x) => (
              <circle key={x} cx={x} cy="48" r="1.4" fill={accent} opacity="0.85" />
            ))}
          </svg>
          {/* Hidden Photo to retain import / fallback type safety. */}
          <Photo src={undefined} style={{ display: "none" }} />
        </div>

        <div style={{ fontFamily: font, fontSize: 28, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          SEVGI KUNI · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
